import React from "react";
import { Helmet } from "react-helmet";
import { Main, HiddenHeader } from "../global/GlobalStyles";
import ContentCard from "../components/Main/About/ContentCard/ContentCard";
import CtaSection from "../components/global/Cta/CtaSection";
import { ctaData } from "../data/global/CtaData";

const About = ({ data }) => {
  return (
    <>
      <Helmet>
        <title>About - We Are More Than a Brand</title>
        <meta
          name="description"
          content="Empowering businesses with innovative web development, AI automation, and robust network solutions to navigate the digital frontier. Welcome to BitTech, where we turn visions into digital reality."
        />
      </Helmet>
      <Main>
        <HiddenHeader>About Us</HiddenHeader>
        {data && <ContentCard data={data.sectionOne} />}
        {data && <ContentCard reverse light gap data={data.sectionTwo} />}
        {data && <ContentCard light data={data.sectionThree} />}
        <CtaSection data={ctaData} />
      </Main>
    </>
  );
};

export default About;
